import { createContext } from 'react';
import { Container } from 'inversify';

/**
 * Container context for Inversify DI container
 */
export const ContainerContext = createContext<Container>(null as unknown as Container);

ContainerContext.displayName = 'ContainerContext';
